<div >
  <div class="mb-2">
    @for (comment of comments$ | async; track comment) {
      <div class="comment mx-auto px-4">
        <div class="flex">
          <div class="comment-left">
            <app-staff-photo [staffId]="comment.staffId" size="small"></app-staff-photo>
          </div>
          <div class="p-d-flex p-ai-center p-mb-2 " style="width: 100%; flex-grow: 1;">
            <div class="comment-right">
              <div class="comment-header d-flex flex-row">
                <div class="comment-name p-2">{{comment.staff?.first}} {{comment.staff?.last}}</div>
                <div class="comment-date p-2">{{comment.commentDate | date:'medium'}}</div>
              </div>
              <div class="comment-body px-6">
                <p>{{comment.commentText}}</p>
              </div>
            </div>
            <div style="text-align: right; margin-left: auto;">
              <button (click)="editComment(comment.workItemCommentId)" pButton type="button" icon="pi pi-pencil"></button>
              <p-dialog [(visible)]="displayModal" modal="true" [dismissableMask]="true" header="Edit Comment">
                <div class="p-fluid">
                  <div class="p-field">
                    <textarea id="comment" [(ngModel)]="commentText" rows="5" cols="30" pTextarea></textarea>
                  </div>
                </div>
                <ng-template #footer>
                  <p-button  label="Save Changes" (click)="onCommentEditedSave()"></p-button>
                </ng-template>
              </p-dialog>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  @if (allowNewComments) {
    <app-work-item-comment class="ms-4" [workItemId]="workItemId"
    (commentSaved)="onCommentSaved($event)"></app-work-item-comment>
  }

</div>